import { IReportingData } from '../../../models/interfaces/IReportingData'

export const selectReportingData = ({
  reportingData: reportingDataState,
}: {
  reportingData: IReportingData
}) => reportingDataState.datasetKey
